import * as React from "react";
import Paper from "@mui/material/Paper";

import Indexdasbord from "../../../composant/navbar/indexDashbord";
import {
  Box,
  Button,
  Grid,
  Select,
  TextField,
  Typography,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";

import { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  GetCommandEvent,
} from "../../../store/slice/CommandDahbordSlice";
import { TableCommands } from "../../../composant/Tables/TableCommands";
import { useState } from "react";
const defaultColumns = [
  { id: 1, align: "center", minWidth: "60px", label: "code" },
  { id: 2, align: "center", minWidth: "60px", label: "prix" },
  { id: 3, align: "center", minWidth: "60px", label: "status" },
  { id: 4, align: "center", minWidth: "60px", label: "paiment status" },
  { id: 5, align: "center", minWidth: "60px", label: "Date" },
  { id: 6, align: "center", minWidth: "60px", label: "Original" },
  { id: 7, align: "center", minWidth: "60px", label: "Traite" },
  { id: 8, align: "center", minWidth: "60px", label: "Action" },
];
export default function PageCommandEventDashbord() {
  return (
    <>
      <Indexdasbord
        Children={
          <Box sx={{ overflow: "hidden" }}>
            <CommandDashbord />
          </Box>
        }
      />
    </>
  );
}

export function CommandDashbord({ filterDisplay = true }) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const { commands } = useSelector(
    (state) => state.commands
  );


  const [codeFilter, setCodeFilter] = useState("");
  const dispatch = useDispatch();

  const { status } = useSelector((state) => state.commands);
  const [statusSelect, setStatusSelect] = useState(null);
  const [StatusPaiment, SetStatusPaiment] = useState(null);
  const [debouncedCode, setDebouncedCode] = useState(codeFilter);
  function reset() {
    setCodeFilter("");
  }

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedCode(codeFilter);
      setPage(0);
    }, 1000);
    return () => clearTimeout(handler);
  }, [codeFilter]);

  const getCommadParData = useCallback(() => {
    const data = {
      page,
      rowsPerPage,

      codeFilter: debouncedCode.trim() || "",
      statusId: statusSelect || null,
      StatusPaiment:
        StatusPaiment === 0 || StatusPaiment === 1 ? StatusPaiment : null,
    };

    dispatch(GetCommandEvent(data));
  }, [dispatch, page, rowsPerPage, debouncedCode, statusSelect, StatusPaiment]);

  useEffect(() => {
    getCommadParData();
  }, [page, rowsPerPage, getCommadParData]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <Grid container sx={{ padding: "2%" }} spacing={2}>
      <Grid item xs={6}>
        <Typography variant="h4">Orders</Typography>
      </Grid>

      <Grid item xs={12}>
        <Paper sx={{ padding: "2%", minHeight: "600px" }}>
          <Grid container spacing={2}>
            <Grid item xs={3} padding="2%">
              <TextField
                label="code"
                type="number"
                variant="outlined"
                sx={{ background: "#F8F8F8" }}
                value={codeFilter}
                onChange={(e) => setCodeFilter(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={3} padding="2%">
              <FormControl fullWidth sx={{ background: "#F8F8F8" }}>
                <InputLabel id="status-label">Statut</InputLabel>
                <Select
                  labelId="status-label"
                  id="status"
                  value={statusSelect}
                  label="Statut"
                  onChange={(e) => {
                    setStatusSelect(e.target.value);
                    setPage(0);
                  }}
                >
                  <MenuItem value={null}>All</MenuItem>
                  {status.map((s) => (
                    <MenuItem value={s.id}>{s.NameStatus}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={3} padding="2%">
              <FormControl fullWidth sx={{ background: "#F8F8F8" }}>
                <InputLabel id="status-label">Paiment status</InputLabel>
                <Select
                  labelId="status-label"
                  id="status"
                  value={StatusPaiment}
                  label="Paiment status"
                  onChange={(e) => {
                    SetStatusPaiment(e.target.value);
                    setPage(0);
                  }}
                >
                  <MenuItem value={null}>All</MenuItem>
                  <MenuItem value={1}>Payé</MenuItem>
                  <MenuItem value={0}>Non payé</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={3} padding="2%">
              <Button variant="contained" onClick={reset}>
                Réinitialiser
              </Button>
            </Grid>

            <Grid item xs={12}>
              <TableCommands
                commands={commands}
                refreshCommands={getCommadParData}
                rowsPerPage={rowsPerPage}
                page={page}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                columns={defaultColumns}
              />
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
}
